import React from 'react';

import { Box } from '@chakra-ui/react';

import { MeshMavenWithOrangeBulb } from 'assets/assetsV1/iconComponents/MeshMavenWithOrangeBulb';

import { Button } from 'uiToolkitV1/Button';
import { Tooltip } from 'uiToolkitV1/Tooltip';

function MeshIconButton({
  isDisabled = false,
  disabledReason = 'Ai',
  onClick = () => {},
  tooltipText = 'Help me write',
}) {
  return (
    <Tooltip label={isDisabled ? disabledReason : tooltipText}>
      <Box alignSelf="center">
        <Button
          EndIcon={MeshMavenWithOrangeBulb}
          endIconProps={{ boxSize: '56px' }}
          onClick={onClick}
          disabled={isDisabled}
          background="transparent !important"
          height="auto !important"
          padding="0px !important"
        />
      </Box>
    </Tooltip>
  );
}

export default MeshIconButton;
